import script from "./Table4WorkspaceCollectFiles2.vue?vue&type=script&setup=true&lang=js"
export * from "./Table4WorkspaceCollectFiles2.vue?vue&type=script&setup=true&lang=js"

import "./Table4WorkspaceCollectFiles2.vue?vue&type=style&index=0&id=fe6fb2ec&lang=scss&scoped=true"
import "./Table4WorkspaceCollectFiles2.vue?vue&type=style&index=1&id=fe6fb2ec&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=2&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe6fb2ec"]])

export default __exports__